<div class="notification-panel" (click)="preventClose($event)">
  <!-- Header -->
  <div class="notification-panel__header">
    <span class="notification-panel__title">{{ 'notifications.title' | translate }}</span>
    <button
      class="notification-panel__mark-all"
      (click)="onMarkAllAsRead()"
      *ngIf="(unreadCount$ | async)! > 0"
    >
      {{ 'notifications.mark_all_read' | translate }}
    </button>
  </div>

  <!-- Loading -->
  <div class="notification-panel__loading" *ngIf="loading$ | async">
    <mat-icon class="notification-panel__spinner">sync</mat-icon>
  </div>

  <!-- List -->
  <div class="notification-panel__list" *ngIf="!(loading$ | async)">
    <ng-container *ngIf="(notifications$ | async) as notifications">
      <!-- Empty state -->
      <div class="notification-panel__empty" *ngIf="notifications.length === 0">
        <mat-icon>notifications_none</mat-icon>
        <span>{{ 'notifications.empty' | translate }}</span>
      </div>

      <!-- Notification items -->
      <div
        *ngFor="let notification of notifications"
        class="notification-panel__item"
        [class.notification-panel__item--unread]="!notification.is_read"
        (click)="onNotificationClick(notification)"
      >
        <div class="notification-panel__item-indicator" *ngIf="!notification.is_read"></div>
        <div class="notification-panel__item-content">
          <span class="notification-panel__item-module">{{ getModuleLabel(notification) | translate }}</span>
          <span class="notification-panel__item-title">{{ getNotificationTitleKey(notification) | translate:getNotificationTitleParams(notification) }}</span>
          <span class="notification-panel__item-time">{{ notification.created_at | daysAgoOrLeft: 'ago' : 2 : 'DD/MM/YYYY' }}</span>
        </div>
      </div>
    </ng-container>
  </div>
</div>
